<script>
const numeral = require("numeral");

export default {
  props: {
    ListProject: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      page: 1
    };
  },
  watch: {
    page: {
      handler() {
        this.$emit("pageChange", this.page);
      }
    }
  },
  methods: {
    TruncateToDecimals2(num, type, dec = 2) {
      //   if (!dec) dec = 2;
      const numberFormat = parseFloat(num.toFixed(10));
      const d = numberFormat.toString().split(".");
      if (type == 1) {
        return `${numeral(d[0]).format(0, 0)}`;
      }
      return `${numeral(d[0]).format(0, 0)}${
        d[1] ? `.${d[1].slice(0, dec)}` : ""
      }`;
    }
  }
};
</script>

<template>
  <b-container class="list-customer">
    <b-row>
      <b-col
        cols="12"
        sm="6"
        lg="6"
        xl="3"
        v-for="project in ListProject.data"
        :key="`project-${project.project_id}`"
      >
        <div class="box-project-outer">
          <div class="box-project">
            <div class="title">{{ project.project_name }}</div>
            <div class="sub-title" v-html="project.project_introduce"></div>
            <div class="image">
              <img :src="`${ListProject.url}${project.project_avata}`" alt="" />
            </div>
            <div class="detail-project">
              <div class="line line-1">
                <div class="left">Tổng gọi vốn</div>
                <div class="right">
                  {{
                    TruncateToDecimals2(parseFloat(project.total_call_project))
                  }}
                  VND
                </div>
              </div>
              <div class="line line-2">
                <div class="left">Doanh Thu</div>
                <div class="right">{{ project.project_revenue_month }}</div>
              </div>
              <div class="line line-2">
                <div class="left">Ngày Gọi Vốn</div>
                <div class="right">{{ project.inves_start_date }}</div>
              </div>
              <router-link
                :to="{
                  name: 'ProjectDetail',
                  params: { slug: project.project_slug }
                }"
                class="customer-link"
              >
                Đầu Tư Ngay
              </router-link>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12" v-if="ListProject.total > 1">
        <div class="pagination">
          <div
            v-for="indexPage in ListProject.total"
            :key="indexPage"
            class="dot"
            :class="page == indexPage ? 'dot-active' : ''"
            @click="page = indexPage"
          ></div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss">
.list-customer {
  @media (max-width: 1440px) and (min-width: 1200px) {
    .col-xl-3 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      width: 33.33333333%;
    }
  }
  .pagination {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    @media (max-width: 575px) {
      margin-top: 20px;
    }
    .dot {
      cursor: pointer;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #999999;
      margin: 0px 10px;
      &.dot-active {
        background-color: #363795;
      }
    }
  }

  .box-project-outer {
    width: 100%;
    height: 375px;
    margin: 15px auto;
    .box-project {
      width: 100%;
      height: 355px;
      background-color: #fff;
      border: 2px solid #00389b;
      border-radius: 25px;
      display: flex;
      position: relative;
      flex-direction: column;
      .title {
        color: #003395;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        padding: 10px 5px 5px;
      }
      .sub-title {
        p {
          color: #003395;
          text-align: center;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          padding: 0px 5px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 5px;
          display: none !important;
          &:first-child {
            display: -webkit-box !important;
          }
        }
      }
      .image {
        position: relative;
        overflow: hidden;
        margin: 5px 0px 0;
        height: 175px;
        &:hover {
          transition: all 1s;
          img {
            transition: all 1s;
            transform: scale(1.05);
          }
        }
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          object-fit: cover;
          object-position: center;
        }
      }
      .detail-project {
        background: linear-gradient(to bottom, #008cff, #003395);
        display: flex;
        flex-direction: column;
        //   flex-grow: 1;
        border-radius: 0 0 20px 20px;
        padding: 10px 10px 0;
        .line {
          display: flex;
          font-size: 13px;
          font-weight: 600;
          .left {
            flex: 0 0 100px;
            text-transform: capitalize;
            border-right: 1px solid #fff;
          }
          .right {
            flex: 1 1 auto;
            padding-left: 4%;
          }
        }
        .customer-link {
          background: linear-gradient(to bottom, #008cff, #003395);
          border: 2px solid #fff;
          color: #fff;
          height: 40px;
          width: 150px;
          text-transform: uppercase;
          font-weight: 600;
          font-size: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 25px;
          position: relative;
          bottom: -20px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
}
</style>
